export abstract class CollectionRequest {
  start: number;
  num: number;
}
